import styled from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';
import { BsX } from 'react-icons/bs';
import Card from '../Card';

const S = {};

S.Overlay = styled.div`
  position: absolute;
  z-index: 60;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: ${palette('bgBodyTransparent')};
  transition: ${theme('transition')};
  opacity: ${ifProp('show', '1', '0')};
`;

S.Dialog = styled(Card)`
  position: relative;
  border-radius: ${theme('borderRadius.lg')};
  box-shadow: ${theme('shadow.lg')};
  padding: ${theme('spacing.xl')};
  width: 600px;
  transition: ${theme('transition')};
  margin-top: ${ifProp('show', theme('spacing.xxxl'), theme('spacing.xl'))};
  opacity: ${ifProp('show', '1', '0')};
`;

S.Close = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
  color: ${palette('asphalt')};
  cursor: pointer;
  &:hover {
    color: ${palette('primary')};
  }
`;

S.XIcon = styled(BsX)`
  width: 24px;
  height: 24px;
`;

S.Content = styled.div`
  margin: ${theme('spacing.xl')} 0;
  color: ${palette('asphalt')};
  line-height: 1.5;
`;

S.Actions = styled.footer`
  display: flex;
  justify-content: flex-end;
  > * {
    margin-left: ${theme('spacing.md')};
  }
`;

export default S;
